import React, { useEffect, useState, useContext } from 'react';
import DefaultDashboard from './dashboard/DefaultDashboard';
import PolarCareDashboard from './dashboard/PolarCareDashboard';
import ClientDashboard from './dashboard/ClientDashboard';
import ProfileContext from '../../services/profileContext';
import ShipBookingDashboard from './dashboard/ShipBookingDashboard';
import helpers from '../../services/helpers';
 
export default function HomePage (){
    const {
        account
    } = useContext(ProfileContext);
    const base_root = window.location.host
    const main_domain = helpers.getMainDomain()

    // if(base_root === "polarcare.polar-air.com" || base_root === "polarcare-staging.polar-air.com"){
    //     return <PolarCareDashboard />
    // }

    // if(account?.user.type === 'customer'){
    //     return <ClientDashboard />
    // }

    // if(base_root === "app.sanricardoshipping.com" || 
    //     base_root === "dashboard.sanricardoshipping.com" || 
    //     base_root === "admin.sanricardoshipping.com" || 
    //     base_root === "booking.sanricardoshipping.com" ||
    //     base_root === "sandbox.sanricardoshipping.com" ||
    //     base_root === "sanricardoshipping.com"
    // ){
    //     return <ShipBookingDashboard />
    // }

    if(main_domain === "polar-air.com"){
        return <PolarCareDashboard />
    }
    
    if(main_domain === "sanricardoshipping.com"){
        return <ShipBookingDashboard />
    }
    
    if(account?.user.type === 'customer'){
        return <ClientDashboard />
    }
    
    return <PolarCareDashboard />
    //return <ShipBookingDashboard />
    return <DefaultDashboard />
}